import { useCallback, useState } from 'react'
import type { ViewStateChangeEvent } from 'react-map-gl/maplibre'

export interface SyncedView {
  longitude: number
  latitude: number
  zoom: number
}

/** One view state shared by both compare panes — pass viewState + onMove to each Map. */
export function useSyncedViewState(initial: SyncedView) {
  const [viewState, setViewState] = useState<SyncedView>(initial)
  const onMove = useCallback((e: ViewStateChangeEvent) => {
    setViewState({
      longitude: e.viewState.longitude,
      latitude: e.viewState.latitude,
      zoom: e.viewState.zoom,
    })
  }, [])
  return { viewState, onMove }
}
